import React, { Component } from 'react';
import { Coach } from './coach';
import { Team } from './team';
// import { Captain } from './captain';
import { Player } from './player';
import Translator from './../../../requests/apa/Translator';
import { RouteComponentProps } from 'react-router-dom';
import Device from '../../../devices/device';
import Assets from './../../../requests/apa/Asset';
import api from './../../requests/api/';
import './_styles.scss';
import Utils from 'src/utils/Utils';
class VcardTeam extends Component<RouteComponentProps> {
    constructor(props: any) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
    }
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    state = {
        imgBackground: '',
        coachData: {
            coachImage: '',
            coachName: '',
            roleName: '',
        },
        teamData: {
            teamAbbreviation: '',
            teamName: '',
            logo: '',
        },
        capData: {
            capRole: 'Capitán',
            capName: 'Manuel Reuer',
            capImage:
                'https://images.sports.gracenote.com/images/lib/basic/person/pp_nationalteam/large/953231.jpg',
        },
        playerData: {
            idTeam: '',
            idPlayer: '',
            title: '',
        },
    };

    private async getTeamData() {
        const {
            match: {
                params: { teamId },
            },
        } = this.props;
        const data = await api.getTeam(teamId);
        const { roleName, name, image } = data.coach;

        const { name: teamName, nameAbbrev, logo } = data.team;

        this.setState({
            coachData: {
                coachImage: image,
                coachName: name,
                roleName,
            },
            teamData: {
                teamName,
                teamAbbreviation: nameAbbrev,
                logo,
            },
            playerData: {
                idTeam: teamId,
                title: Translator.get('talent_player_detail_title_ribbon_players_label'),
                idPlayer: undefined,
            },
        });
    }

    onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch(currentKey){
            case "BACK":
                const { history } = this.props;
                history.goBack();
            break;
            case "DOWN":
              const component = document && document.activeElement && document.activeElement.id;
              const playerComponent = document.getElementById('soccerPlayers');
              if(component && (!component.includes('menu') && component !== '' && playerComponent !== null)){
                const element = document.getElementById('scrollMatch');
                if (element) element.scrollTop = 500;
              }
            break;
        }
    }

    componentDidMount() {
        this.getTeamData();
        document.querySelector('.team-main-container')?.scrollIntoView();
        Utils.setInitialFocus('#team-name')
        document.addEventListener('keydown', this.onKeyPress, true);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyPress, true);
    }

    private imgBackground() {
        const urlImg = Assets.get('talent_player_detail_header_img');
        return <img src={urlImg} alt={urlImg} />;
    }

    public scrollFocus() {
        document.querySelector('.team-main-container')?.scrollIntoView();
    }

    public render(): React.ReactNode {
        const {
            teamData,
            coachData,
            // capData,
            playerData,
        } = this.state;

        return (
            <div id="scrollMatch">
             
                  <div
                      id="container-team"
                      className="team-main-container"
                      style={{
                          backgroundImage: `url(${Assets.get('talent_player_detail_header_img')})`,
                      }}
                  >
                      <Team teamData={teamData} scrollFocus={this.scrollFocus} />
                      <Coach coachData={coachData} />
                      <div className="first-container-team" >
                        <Player playerData={playerData} key={Math.random() * 10} {...this.props}/>
                      </div>
                  </div>
            </div>
        );
    }
}

export default VcardTeam;



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardTeam/index.tsx